import { APP_INITIALIZER, Provider } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, map, Observable } from "rxjs";
import { UserControllerService } from "./partials/services/user-controller.service";
import { TranslateService } from "@ngx-translate/core";
import { telegramLanguageCode } from "./partials/utils/language";

export const appConfigInit: Provider = {
  provide: APP_INITIALIZER,
  useFactory: (router: Router, userControllerService: UserControllerService, translate: TranslateService) =>
    (): Observable<boolean | Promise<boolean>> => {
      const url: URL = new URL(window.location.href);
      const queryParamsReferralLink: string | null = url.searchParams.get('referralLink');
      const queryParamsHash: string | null = url.searchParams.get('hash');
      const paramsUser: {userId: string | null, fullName: string | null, username: string | null} = {
        userId: (url.searchParams.get('userId') ? url.searchParams.get('userId') : ''),
        fullName: (url.searchParams.get('fullName') ? url.searchParams.get('fullName') : ''),
        username: (url.searchParams.get('username') ? url.searchParams.get('username') : '')
      }
      const form = {
        referralCode: queryParamsReferralLink,
        reportedHash: queryParamsHash
      }

      return userControllerService.getUser(form, paramsUser).pipe(
        map(async (user) => {
          console.log(user)
          if (!user) {
            return await router.navigate(['401']);
          }
          // Language priority: BE-provided user.language > Telegram's
          // language_code (so the in-app language follows the user's Telegram
          // setting on every load) > whatever was last stored (the in-app
          // dropdown still writes here for the current session) > 'en'.
          const lang = (user.language || telegramLanguageCode() || localStorage.getItem('lang') || 'en').toLowerCase();
          translate.use(lang);
          localStorage.setItem('lang', lang);
          return true;
        }),
        catchError(() => {
          const lang = telegramLanguageCode() || localStorage.getItem('lang') || 'en';
          translate.use(lang);
          return router.navigate(['401']);
        }))
    }
  ,
  deps: [
    Router,
    UserControllerService,
    TranslateService
  ],
  multi: true
};
